import { useHistory } from 'react-router-dom';

import { AppContainer } from 'components/Container';
import { BackLink } from 'components/Link/BackLink';
import { subHeader } from './styles.module.scss';

const SubHeader = () => {
  const history = useHistory();
  return (
    <div role="navigation" className={subHeader}>
      <AppContainer>
        <BackLink onClick={() => history.goBack()}>Back</BackLink>
      </AppContainer>
    </div>
  );
};

export { SubHeader };
